import type { TextareaPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum TextAreaSize {
  SMALL = 'small',
  LARGE = 'large',
}

export enum TextAreaIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum TextAreaState {
  SUCCESS = 'success',
  ERROR = 'error',
  DISABLED = 'disabled',
}

export type PassThroughMeridiaTextArea =
  PassThrough<TextareaPassThroughOptions> & {
    wrapper?: { class: string };
    helper_text?: { class: string };
    icon?: { class: string };
    clearIcon?: { class: string };
  };
